import {Action} from '@ngrx/store';


export const PAGE_STATE_RESET = '[MandantenAuswahl] Page State reset';


// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

export type Actions =
    PageStateResetAction
    ;
